import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    cancel: 'Cancel',
  },
  de: {
    cancel: 'Abbrechen',
  },
});
